import React from 'react';

const ContainerContent = ({ children }) => <div className="relative mx-auto w-[95%] max-w-[1700px]">{children}</div>;

export default ContainerContent;
